export const LOGIN_ID_VALIDATION = /^[A-Za-z0-9]{4,16}$/;

export const PASSWORD_VALIDATION =
  /^(?=.*[a-zA-Z])(?=.*[!@#$%^*+=-])(?=.*[0-9]).{8,20}$/;

export const PASSWORD_WHITESPACE_VALIDATION = /^\S+$/;

export const EMAIL_VALIDATION =
  /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])+@[0-9a-zA-Z.-]([-_.]?[0-9a-zA-Z])+\.[a-zA-Z]{2,4}$/i;

export const PHONE_VALIDATION = /^01(?:0|1|[6-9])(?:\d{3}|\d{4})\d{4}$/;
